<template>
  <div class="evaluate_list">
    <div class="eval_title">客户评价<span>共{{evalCount}}条</span></div>
    <div class="eval_tag" v-if="evalTags.length">
      <div class="tag_item" v-for="(item,index) in evalTags" :key="index">
        {{item.name}}（{{item.evaluateCount}}）
      </div>
    </div>
    <div class="eval_list" v-if="List.length&&!pro">
      <div  class="eval_item" v-for="(item,index) in List" :key="index">
        <img v-if="item.avatarUrl" :src="item.avatarUrl" v-load="'oPicXS'" > 
        <img v-else src="@/assets/img/empty.png" >
        <div class="eval_info">
          <div class="info_head">
            <p class="van-ellipsis">{{item.name||'游客'}}<span>{{item.timeStr}}</span></p>
            <van-rate v-model="item.score" readonly color="#ff5c00" size="0.22rem" void-color="#cccccc" />
          </div>  
          <div class="info_con">
            {{item.content}}
          </div>
        </div>
      </div>

    </div>
    <div class="eval_list" v-if="List.length&&pro">
      <div  class="eval_item-p" v-for="(item,index) in List" :key="index">
        <img v-if="item.avatarUrl" :src="item.avatarUrl" v-load="'oPicXS'" >
        <img v-else src="@/assets/img/empty.png" >
        <div class="eval_info">
          <div class="info_head">
            <p class="van-ellipsis">{{item.name||'游客'}}<span>{{item.timeStr}}</span></p>
            <van-rate v-model="item.score" readonly color="#ff5c00" size="0.22rem" void-color="#cccccc" />
          </div>
          <div class="info_con">
            {{item.content}}
          </div>
        </div>
      </div>

    </div>
    <div v-if="List.length==0" style="padding: 0.3rem 0 0.5rem;text-align: center;">暂无内容</div>
    <div class="more_btn loading" v-if="Loading&&!finished"><img src="@assets/img/new/icon-loading.png" />loading...</div>
    <div class="more_btn" @click="loadMore" v-if="!finished">展开更多<i class="iconfont icon-right-fill "></i></div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
export default {  
  name: "evaluate-list",
  props:{
    evalCount:{
      type:Number,
      default:0,
    },
    evalTags:{
      type:Array,
      default:()=>{
        return []
      },
    },
    pro:{
      type:Boolean,
      default:false,
    },
    productId:String
  },
  data() {
    return {
      Loading: false, //展品动态加载状态
      finished: false, //展品加载是否完成状态
      List: [1], //展品列表
      pageSize:1,
      pageIndex: 1,
      queryExhibitorEvaluate:{},  //查询展商评价
      queryProductEvaluate:{},

    };
  },
  components: {},
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
    }),
    exhibitorId(){
      return this.$route.params.id;
    }
  },
  created() {
    Object.assign(this.$data, this.$options.data);
    this.init();
  },
  methods: {
    ...mapActions({
      getAddedList: "connection/getAddedList",
    }),
    init(){
      if (this.pro==false){
        this.getData();
      }
      else{
        this.getProductEvaluate()
      }
    },
    getData(isLoad=false){
      // console.log(this.exhibitorId);
      let query=gql`
        query queryExhibitorEvaluate($page:Int!,$size:Int!,$where:String!,$order:String ){
          queryExhibitorEvaluate(query:{page:$page,size:$size,where:$where,order:$order}){
            hasNextPage
            pageIndex
            items{
              id
              content
              avatarUrl
              createAt
              name
              score
              replyType
            }
          }
        }`
      let where={
        "Equal":{
          "n":"exhibitorId",
          "v":this.exhibitorId
        },
        "Equal_isDeleted":{
          "n":"isDeleted",
          "v":0
        },
        "Equal_isShow":{
          "n":"isShow",
          "v":1
        },
        "Equal_parentId":{
          "n":"parentId"
        }
      }
      let order=[
        {
          "N":"createAt",
          "v":0
        }
      ]
      let page=this.pageIndex;
      let size=this.pageSize
      this.$apollo.addSmartQuery("queryExhibitorEvaluate",{ 
        query:query,
        variables:{
          page:page,
          size:size,
          where:JSON.stringify(where),
          order:JSON.stringify(order)
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          // console.log(data,'评价data2')
          let res=JSON.parse(JSON.stringify(data.data.queryExhibitorEvaluate));
          res.items.forEach(el => {
            //  let createAt=el.createAt.replace(/\-/g,'/');
            //  el.item=createAt
              let time=moment().from(el.createAt);
              let nowTime=moment(new Date()).diff(el.createAt,'minute');
              if(nowTime==0){
                el.timeStr='刚刚';
              }else if(time.indexOf('分钟')!=-1){
                el.timeStr=parseInt(time)+' 分钟前'
              }else if(time.indexOf('小时')!=-1&&parseInt(time)<8){
                el.timeStr=parseInt(time)+' 小时前';
              }else{
                let timeMoment=moment(el.createAt).calendar(moment(), {
                    sameDay: 'HH:mm',
                    lastDay: '[昨天] HH:mm',
                    lastWeek: '[上周]dd',
                    sameElse: 'YYYY/MM/DD',
                });
                el.timeStr=timeMoment;
              }
          });
          // console.log('评价index',this.pageIndex)
          if(this.pageIndex<=1){
            this.List=res.items
          }else{
            this.List=[...new Set([...this.List,...res.items])];
          }  
          this.Loading=false;
          if(isLoad){
            this.pageIndex=res.pageIndex
          }else{
            this.pageIndex=0
            this.pageSize=20
          }
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.Loading=false;
          console.log('err',err)
        }
      })
    },
    getProductEvaluate(proisLoad=false){
      let query=gql`
        query queryProductEvaluate($page:Int!,$size:Int!,$where:String!,$order:String ){
          queryProductEvaluate(query:{page:$page,size:$size,where:$where,order:$order}){
            hasNextPage
            pageIndex
            items{
              id
              content
              avatarUrl
              createAt
              name
              score
            }
          }
        }`
      let where={
        "Equal":{
          "n":"productId",
          "v":this.productId
        },
        "Equal_isDeleted":{
          "n":"isDeleted",
          "v":0
        },
        "Equal_isShow":{
          "n":"isShow",
          "v":1
        },
        "Equal_parentId":{
          "n":"parentId"
        }
      }
      let order=[
        {
          "N":"createAt",
          "v":0
        }
      ]
      let page=this.pageIndex;
      let size=this.pageSize
      this.$apollo.addSmartQuery("queryProductEvaluate",{
        query:query,
        variables:{
          page:page,
          size:size,
          where:JSON.stringify(where),
          order:JSON.stringify(order)
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          console.log(data,'评价data33333')
          let res=JSON.parse(JSON.stringify(data.data.queryProductEvaluate));
          res.items.forEach(el => {
            //  let createAt=el.createAt.replace(/\-/g,'/');
            //  el.item=createAt
            let time=moment().from(el.createAt);
            if(time.indexOf('分钟')!=-1){
              el.timeStr=parseInt(time)+' 分钟前'
            }else if(time.indexOf('小时')!=-1&&parseInt(time)<8){
              el.timeStr=parseInt(time)+' 小时前';
            }else{
              let timeMoment=moment(el.createAt).calendar(moment(), {
                sameDay: 'HH:mm',
                lastDay: '[昨天] HH:mm',
                lastWeek: '[上周]dd',
                sameElse: 'YYYY/MM/DD',
              });
              el.timeStr=timeMoment;
            }
          });
          // console.log('评价index',this.pageIndex)
          if(this.pageIndex<=1){
            this.List=res.items
          }else{
            this.List=[...new Set([...this.List,...res.items])];
          }
          this.Loading=false;
          if(proisLoad){
            this.pageIndex=res.pageIndex
          }else{
            this.pageIndex=0
            this.pageSize=20
          }
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.Loading=false;
          console.log('err',err)
        }
      })
    },
    loadMore() {
      if (this.Finished) return;
      this.pageIndex += 1;
      if (this.pro==false){
        this.getData(true);
      }
     else{
       this.getProductEvaluate(true)
      }
    },
  }
};
</script>

<style scoped lang="scss">
//客户评价
.evaluate_list{
  background: #fff;
  border-radius: 0.3rem;
  padding: 0.3rem 0.25rem 0;
  color: #333;
  .eval_title{
    font-size: 0.3rem;
    color: #333;
    font-weight: 600; 
    span{
      font-size: 0.2rem;
      color: #999;
      margin-left: 0.2rem;
      font-weight: normal;
    }
  }
  .eval_tag{
    margin-top: 0.08rem;
    display: flex;
    flex-wrap: wrap;
    max-height: 1.24rem;
    overflow: hidden;
    .tag_item{
      padding: 0 0.06rem 0 0.16rem;
      margin-right: -0.2rem;
      background-color: #ff8640;
      color: #fff;
      font-size: 0.22rem;
      height: 0.42rem;
      display: flex;
      align-items: center;
      justify-self: center;
      border-radius: 0.03rem;
      margin: 0.2rem 0.2rem 0 0 ;
    }
  }
  .eval_list{
    .eval_item{
      padding: 0.3rem 0 ;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      img{
        margin-right: 0.18rem;
        flex-shrink: 0;
        width:0.6rem;
        height: 0.6rem;
        border-radius: 50%;
        // object-fit: cover;
      }
      .eval_info{
        width:calc(100% - 0.78rem);
        .info_head{
          width: 100%;
          display: flex;
          justify-content: space-between;
          p{
            font-size: 0.26rem;
            color: #666;
            span{
              margin-left: 0.1rem;
              font-size: 0.2rem;
              color: #999;
            }
          }
          .van-rate{
            display: flex;
            align-items: center;
          }
        }
        .info_con{
          margin-top: 0.2rem;
        }
      }
    }
    .eval_item-p{
      padding: 0.3rem 0 ;
      display: flex;
      img{
        margin-right: 0.18rem;
        flex-shrink: 0;
        width:0.6rem;
        height: 0.6rem;
        border-radius: 50%;
        // object-fit: cover;
      }
      .eval_info{
        width:calc(100% - 0.78rem);
        .info_head{
          width: 100%;
          display: flex;
          justify-content: space-between;
          p{
            font-size: 0.26rem;
            color: #666;
            span{
              margin-left: 0.1rem;
              font-size: 0.2rem;
              color: #999;
            }
          }
          .van-rate{
            display: flex;
            align-items: center;
          }
        }
        .info_con{
          margin-top: 0.2rem;
        }
      }
    }
  }
  .more_btn{
    font-size: 0.26rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 0.75rem;
    width: calc(100% + 0.5rem);
    color: #595757;
    &.loading{
      text-align: center;
      img {
        width: 0.30rem;
        height: 0.30rem;
        margin-right: 0.1rem;
        animation: 1s loader-01 linear infinite;
      }
    }
    .iconfont{
      color: #999;
      display: inline-block;
      transform: rotate(90deg) translateX(1px);
      &.shang{
        transform: rotate(-90deg) translateX(-1px);
      }
    }
  }
  @keyframes loader-01 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
</style>
